<template>
    <!-- Card Component -->
    <div class="card-wrapper">
        <div class="card playlist">
            <div class="card-body">
                <!-- Image Container -->
                <div class="img-wrap p-0 image-container">
                    <!-- Image -->
                    <img
                        class="card-img-top-virtuoso"
                        :src="playlist.cardImg"
                        :alt="playlist.name"
                        loading="lazy"
                    />

                    <template v-if="playlist.progress">
                        <div class="progress">
                            <div class="progress-bar" role="progressbar" :style="'width:'+ progressPercentage +'%;'"></div>
                        </div>
                    </template>

                    <!-- Overlay -->
                    <a :href="playlist.playUri" class="overlay">
                        <span class="overlay-text">&#9654; &nbsp;Play all</span>
                    </a>
                </div>

                <!-- Playlist Name -->
                <div v-if="isEditing" class="mt-2">
                    <input
                        type="text"
                        v-model="localPlaylist.name"
                        class="form-control form-control-sm"
                    />
                    <!-- Save Button -->
                    <b-button
                        v-if="isEditing"
                        size="sm"
                        variant="success"
                        @click="savePlaylistName"
                    >
                        Save
                    </b-button>
                </div>
                <div v-else class="mt-2">
                    <h2 class="card-title mb-2">
                        <a :href="playlist.playUri">
                            {{ playlist.name }}
                        </a>
                    </h2>
                </div>

                <!-- Actions -->
                <div class="row mt-2">
                    <div class="col-7">
                        <p class="card-text">
                            Number of Classes: {{ playlist.quick_classes_count }}
                        </p>
                    </div>
                    <div class="col-5 d-flex align-items-center justify-content-end" v-if="!inlineButtons">

                        <!-- Context Menu -->
                        <card-context-menu class="inline ml-2">
                            <a class="dropdown-item" :href="playlist.uri">
                                Edit Playlist
                            </a>
                            <a
                                class="dropdown-item"
                                href="#"
                                @click.prevent="enableEditing"
                            >
                                Rename
                            </a>
                            <a
                                class="dropdown-item"
                                href="#"
                                @click.prevent="deletePlaylist"
                            >
                                Delete
                            </a>
                        </card-context-menu>
                    </div>
                    <div class="col-12 d-flex justify-content-between mt-2" v-else>
                        <a :href="playlist.playUri"
                            class="flex-fill mr-1 btn btn-sm btn-secondary"
                        >
                            Play All
                        </a>
                        <b-button
                            size="sm"
                            variant="secondary"
                            @click="enableEditing"
                            class="flex-fill mx-1"
                        >
                            Rename
                        </b-button>
                        <b-button
                            size="sm"
                            variant="secondary"
                            @click="deletePlaylist"
                            class="flex-fill ml-1"
                        >
                            Delete
                        </b-button>
                    </div>
                </div>
            </div> <!-- End of card-body -->

        </div> <!-- End of card -->
    </div> <!-- End of card-wrapper -->
</template>

<script>
import CardContextMenu from './CardContextMenu.vue'; // Adjust the path as necessary

export default {
    components: {
        CardContextMenu,
    },
    props: {
        playlist: {
            type: Object,
            required: true,
        },
        inlineButtons: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            isEditing: false,
            localPlaylist: { ...this.playlist }, // Local copy for editing
            progressPercentage: 0,
        };
    },

    mounted() {
        if(this.playlist.progress) {
            this.progressPercentage = this.playlist.progress;
        }
    },

    methods: {
        enableEditing() {
            this.isEditing = true;
        },
        async savePlaylistName() {
            try {
                await axios.put(`/api/me/playlists/${this.localPlaylist.id}`, {
                    name: this.localPlaylist.name,
                });
                // Update the original playlist data
                this.playlist.name = this.localPlaylist.name;
                this.isEditing = false;
            } catch (error) {
                console.error('Error updating playlist name:', error);
                alert('Failed to update playlist name.');
                // Revert to the original name
                this.localPlaylist.name = this.playlist.name;
                this.isEditing = false;
            }
        },
        async deletePlaylist() {
            if (
                confirm(
                    `Are you sure you want to delete the playlist "${this.playlist.name}"?`
                )
            ) {
                try {
                    await axios.delete(`/api/me/playlists/${this.playlist.id}`);
                    // Emit an event to the parent to remove this playlist from the list
                    this.$emit('playlist-deleted', this.playlist.id);
                } catch (error) {
                    console.error('Error deleting playlist:', error);
                    alert('Failed to delete playlist.');
                }
            }
        },
    },
    watch: {
        // Watch for changes in the playlist prop and update localPlaylist accordingly
        playlist: {
            handler(newVal) {
                this.localPlaylist = { ...newVal };
            },
            deep: true,
        },
    },
};
</script>
